module.exports = __webpack_public_path__ + "img/2.c615f9fa.gif";